/* esm.sh - @radix-ui/react-direction@1.1.1 */
export * from "/*@radix-ui/react-direction@1.1.1/esnext/react-direction.mjs";
